import React, {
  Component
} from 'react'
import './index.scss';
import arrowImg from '../../assets/image/arrow@3x.png';
import arrowImg2 from '../../assets/image/arrow2@3x.png';
import api from '../../service/api';
import LazyLoadImg from '../aelComponent/LazyLoadImg';

class ProductCard extends Component {
  render() {
    const {
      img,
      btn,
      imageText,
      textBlack
    } = this.props || {}
    return (
      img ? (
        <div
          className='productCardBox'
          data-type='discountProductCard'
        >
          <a className='productCardBoxWrap' href={btn?.productID ? `/pd/${btn.productID}/` : ''}>
            <LazyLoadImg image={api.getResource(img)} alt={imageText || 'product image'} className={btn.productID ? 'productImg boxshadow' : 'productImg'} />
          </a>
          {
            imageText && (
              <div className='arrowBox'>
                <LazyLoadImg image={textBlack ? arrowImg2 : arrowImg} alt={'arrow img'} className='arrowImg' />
                <span className={textBlack ? 'productText colorBlack' : 'productText'}>{imageText}</span>
              </div>
            )
          }
          {
            btn?.productID ? (
              <a className='imgBtn flex' href={`/pd/${btn.productID}/`}>
                <div className='productPrice flexItem'>{btn.price}</div>
                <div className='seeMore'>查看详情</div>
              </a>
            ) : null
          }
        </div>
      ) : null
    )
  }
}

export default ProductCard